import React, { useState } from 'react'
import RolesForm from './RolesForm'
import { useParams } from 'react-router-dom';

const EditRolePage = () => {
  const { id } = useParams();
  
  
  
  return (
    <>
    currentRoleId?(<RolesForm formType='edit' currentRoleId={id} ></RolesForm>):''
     
    </>
  )
}

export default EditRolePage
